export default __webpack_public_path__ + "static/media/icon-park_timer (1).d7d6b8b5.svg";